<template>
  <AppModal :value="value" @input="$emit('input', $event)" max-width="500px" persistent>
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:text>
      <v-list>
        <template v-for="(file, i) in fileResults">
          <v-divider v-if="i!=0" :key="`divider-${i}`" />
          <v-list-tile :key="`file-${i}`">
            <v-list-tile-content>
              {{ file.fileName}}
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn @click="handleDownload(file)">Download</v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </template>
  </AppModal>
</template>

<script>
  import {
    downloadFileBytes,
  } from '@/helpers/download'
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      fileResults: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {}
    },
    methods: {
      handleDownload(file) {
        downloadFileBytes(file.fileName, file.data)
      },
    },
  }
</script>